<template>
  <crud-modal
    :title="$t('modals.company.imageDeleteTitle')"
    action="delete"
    :on-submit="submit"
    :on-close="() => $emit('close')"
    :error-message="errorMessage"
  >
    <div class="flex flex-col w-full mb-2">
      <label>{{ $t('modals.company.imageDeleteQuestion') }}</label>
      <img
        :src="image.url"
        class="object-contain w-auto h-64 mb-6 border-2 rounded"
      >
    </div>
  </crud-modal>
</template>

<script>
import CrudModal from '@/components/modals/crud-modal'

import DELETE_COMPANY_IMAGE from '@/graphql/DeleteCompanyImage.gql'
import GET_COMPANY from '@/graphql/GetCompany.gql'

export default {
  components: {
    CrudModal
  },
  props: {
    companyId: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    image: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      delete: null,
      errorMessage: ''
    }
  },
  computed: {
    mimeType () {
      const mimeTypes = {
        office: 'image/png, image/jpeg',
        region: 'image/png, image/jpeg',
        lpValuationHero: 'image/png, image/jpeg'
      }

      return mimeTypes[this.type]
    }
  },
  mounted () {
    this.delete = { ...this.image }
  },
  methods: {
    async submit () {
      await this.$apollo.mutate({
        mutation: DELETE_COMPANY_IMAGE,
        variables: {
          input: {
            companyId: this.companyId,
            type: this.type
          }
        },
        refetchQueries: [
          { query: GET_COMPANY, variables: { id: this.companyId } }
        ]
      })
    }
  }
}
</script>
